import { Row } from '@cof/omni-react';
import { PrimaryHeader } from '@components/global';
import { Box, CTA } from '@components/global';
import styled from '@emotion/styled';
import { useWorkflow } from '@hooks/useWorkflow';

interface MerchantTransactionResponse {
  amount: string;
  merchantName: string;
  merchantImage: string;
  merchantImageAlt: string;
  cardStyle: string;
  last4: string;
}

const HalfRow = styled('div')`
  width: 50%;
  font-size: 1.5em;
  text-align: center;
  align-content: center;
  img {
    max-height: 100%;
    max-width: 100%;
    margin: 0;
  }
`;

export const MerchantTransaction = () => {
  const { templateJson, reqUrl, error } = useWorkflow();
  const {
    amount,
    merchantName,
    merchantImage,
    merchantImageAlt,
    cardStyle,
    last4,
  } = templateJson as MerchantTransactionResponse;

  if (error) {
    console.log(error);
  }

  return (
    <div data-testid="MerchantTransaction">
      <PrimaryHeader>
        Would you like to proceed with this purchase?
      </PrimaryHeader>
      <Box title="Purchase Amount">
        <h2>{`$${amount}`}</h2>
      </Box>
      <Box title="Merchant">
        <Row>
          <HalfRow>{merchantName}</HalfRow>
          <HalfRow>
            <img src={`${reqUrl}${merchantImage}`} alt={merchantImageAlt} />
          </HalfRow>
        </Row>
      </Box>
      <Box>
        <h3
          style={{ textAlign: 'center' }}
        >{`Take out your ${cardStyle} card ending in ${last4} before proceeding.`}</h3>
      </Box>
      <CTA
        primaryText="Yes, continue"
        primaryCallback={() => {
          console.log('yes clicked');
        }}
        secondaryText="No, I don't recognize this device"
        secondaryCallback={() => {
          console.log('no clicked');
        }}
      />
    </div>
  );
};
